// extracted by mini-css-extract-plugin
export default {"art":"style_art__yA-xp","artImg":"style_artImg__cWMkB","artPh":"style_artPh__LDEib"};